<template>
    <div class="detail-box">
        <div class="left-box">
            <Form
                ref="watermarkSettings"
                :label-width="100"
                :model="watermarkSettings"
                :rules="watermarkSettingsRules"
            >
                <FormItem :label="$t('WatermarkManagement.Detail.watermarkSettings.watermarkName')" prop="watermarkName">
                    <Input v-model="watermarkSettings.watermarkName" :maxlength="50" show-word-limit/>
                </FormItem>
                <FormItem :label="$t('WatermarkManagement.Detail.watermarkSettings.position')">
                    <Select v-model="watermarkSettings.position">
                        <Option :value="1">{{ $t('WatermarkManagement.position.leftTop') }}</Option>
                        <Option :value="2">{{ $t('WatermarkManagement.position.leftBottom') }}</Option>
                        <Option :value="3">{{ $t('WatermarkManagement.position.rightTop') }}</Option>
                        <Option :value="4">{{ $t('WatermarkManagement.position.rightBottom') }}</Option>
                        <Option :value="5">{{ $t('WatermarkManagement.position.alignCenter') }}</Option>
                        <Option :value="6">{{ $t('WatermarkManagement.position.bespread') }}</Option>
                    </Select>
                </FormItem>
                <FormItem :label="$t('WatermarkManagement.Detail.watermarkSettings.watermarkType')">
                    <Select
                        v-model="watermarkSettings.watermarkType"
                        :disabled="watermarkSettings.watermarkId != 0"
                    >
                        <Option :value="0">{{ $t('WatermarkManagement.type.image') }}</Option>
                        <Option :value="1">{{ $t('WatermarkManagement.type.text') }}</Option>
                    </Select>
                </FormItem>
                <FormItem :label="$t('WatermarkManagement.Detail.watermarkSettings.isDefault.title')">
                    <Select v-model="watermarkSettings.isDefault">
                        <Option :value="0">{{ $t('WatermarkManagement.Detail.watermarkSettings.isDefault.yes') }}</Option>
                        <Option :value="1">{{ $t('WatermarkManagement.Detail.watermarkSettings.isDefault.no') }}</Option>
                    </Select>
                </FormItem>
                <FormItem :label="$t('WatermarkManagement.Detail.watermarkSettings.opacityPercent')">
                    <Slider v-model="opacityPercent" :min="0" :max="100" style="width: 120px;display: inline-flex;"></Slider>
                    <InputNumber v-model="opacityPercent" :min="0" :max="100" :step="1" style="position: absolute;right: 0px;"></InputNumber>
                </FormItem>
                <div v-if="watermarkSettings.watermarkType == Const.Watermark.Type.Image">
                    <FormItem v-if="id == 0" :label="$t('WatermarkManagement.Detail.watermarkSettings.zoomPercent')">
                        <Slider v-model="watermarkSettings.zoomPercent" :min="0.01" :max="100" :step="0.01" style="width: 120px;display: inline-flex;"></Slider>
                        <InputNumber v-model="watermarkSettings.zoomPercent" :min="0.01" :max="100" :step="0.05" style="position: absolute;right: 0px;" @on-blur="delaySetZoomPercent()"></InputNumber>
                    </FormItem>
                    <FormItem v-if="!watermarkSettings.watermarkId" :label="$t('WatermarkManagement.Detail.watermarkSettings.imagePath.title')" prop="imagePath"  key="imagePath">
                        <Uploader
                            ref="uploader"
                            class="uploader"
                            :action="uploadServer.uploadServerUrl"
                            :type="8"
                            :resize="2"
                            :imageUrl="watermarkSettings.imagePath"
                            :showCloseBtn="false"
                            :full="true"
                            :maxSize="uploadImageLimit"
                            @on-select="onUploadSelect"
                            @on-success="onUploadSuccess"
                            @save="save"
                            @done="onUploadDone"
                        >
                            <Button type="primary" icon="ios-cloud-upload-outline">{{ $t('Button.uploadImg') }}</Button>
                        </Uploader>
                        <small>{{ $t('WatermarkManagement.Detail.watermarkSettings.imagePath.prompt') }}</small>
                    </FormItem>
                </div>
                <div v-else>
                    <FormItem :label="$t('WatermarkManagement.Detail.watermarkSettings.words')" prop="words" key="words">
                        <Input class="input-textarea" type="textarea" v-model="watermarkSettings.words" :maxlength="100" show-word-limit/>
                    </FormItem>
                    <FormItem :label="$t('WatermarkManagement.Detail.watermarkSettings.fontSize')" prop="fontSize" key="fontSize">
                        <InputNumber v-model="watermarkSettings.fontSize" style="width:100%"
                            :precision="0"
                            :min="1"
                            :max="100"
                            :step="1"/>
                    </FormItem>
                    <FormItem :label="$t('WatermarkManagement.Detail.watermarkSettings.fontColor')">
                        <ColorPicker
                            recommend
                            v-model="watermarkSettings.fontColor"
                            class="color-picker"
                        />
                    </FormItem>
                    <FormItem :label="$t('WatermarkManagement.Detail.watermarkSettings.fontFamily')">
                        <Select v-model="watermarkSettings.fontFamily" style="width: 120px">
                            <Option
                                v-for="i in fontFamilyList"
                                :value="i.fontFamily"
                                :key="i.fontFamily"
                            >{{ i.name }}</Option>
                        </Select>
                    </FormItem>
                </div>
                <FormItem>
                    <Button type="primary" :loading="save_loading" @click="debounce(onSaveClick)">{{ $t('Button.save') }}</Button>
                </FormItem>
            </Form>
        </div>
        <div class="right-box">
            <WatermarkPreview :model="watermarkSettings" :fontList="fontFamilyList" style="width: 100%;background-color: #666"></WatermarkPreview>
        </div>
        <Spin v-show="loading" fix class="spin">
            <Icon type="ios-loading" size="18" class="spin-icon-load"></Icon>
            <div>Loading</div>
        </Spin>
    </div>
</template>

<script>
import { mapState } from "vuex";
import api from "@/api/Api";
import { Const } from "@/model/ApiModel";
import helper from "@/assets/helper";
import extend from "extend";
import Uploader from "@/components/upload/upload-pic";
import WatermarkPreview from "@/components/WatermarkPreview";
import { beforeUnloadMixin } from "@/mixin/beforeUnloadMixin";
import HtmlDecode from "@/plugins/htmlDecode";

export default {
    props: ["id"],
    mixins: [beforeUnloadMixin],
    components: {
        Uploader,
        WatermarkPreview
    },
    data() {
        return {
            console: console,
            Const,
            fontFamilyList: [],
            loading: false,
            save_loading: false,
            opacityPercent: 100,
            uploadServer: {
                softwareId: null,
                uploadServerUrl: "",
                uploadServerId: null
            },
            zoomPercent: 50,
            watermarkSettings: {
                watermarkId: 0,
                watermarkName: "",
                watermarkType: 0,
                position: 1,
                isDefault: 1,
                opacity: 1,
                zoomPercent: 50,
                words: "",
                fontSize: 30,
                fontColor: "#000000",
                fontFamily: "",
                imagePath: "",
                content: ""
            },
            watermarkSettingsRules: {
                watermarkName: [
                    {
                        type: "string",
                        required: true,
                        validator: (rule, value, callback) => {
                            if (value.trim().length == 0) {
                                callback(this.$t('WatermarkManagement.Detail.watermarkSettingsRules.watermarkNameLength'));
                            } else {
                                callback();
                            }
                        },
                        message: this.$t('WatermarkManagement.Detail.watermarkSettingsRules.watermarkName')
                    }
                ],
                words: [
                    {
                        type: "string",
                        required: true,
                        validator: (rule, value, callback) => {
                            if (value.trim().length == 0) {
                                callback(this.$t('WatermarkManagement.Detail.watermarkSettingsRules.watermarkNameLength'));
                            } else {
                                callback();
                            }
                        },
                        message: this.$t('WatermarkManagement.Detail.watermarkSettingsRules.words')
                    }
                ],
                fontSize: [
                    {
                        type: "integer",
                        required: true,
                        message: this.$t('WatermarkManagement.Detail.watermarkSettingsRules.fontSize')
                    }
                ],
                imagePath: [
                    {
                        type: "string",
                        required: true,
                        validator: (rule, value, callback) => {
                            // 验证是否选择了图片
                            if (
                                this.watermarkSettings.watermarkType ==
                                Const.Watermark.Type.Image
                            ) {
                                if (this.watermarkSettings.id) {
                                    callback();
                                } else if (this.$refs.uploader.file.id) {
                                    callback();
                                } else {
                                    callback(this.$t('Message.selectImg'));
                                }
                            } else {
                                callback();
                            }
                        }
                    }
                ]
            }
        };
    },
    computed: {
        ...mapState({
            userId: state => state.user.id,
            uploadResult: state => state.uploader.uploadResult,
            uploadPath: state => state.uploader.uploadPath,
            uploaderLoading: state =>
                state.uploader.UploadServer.loadingStatus == "loading",
            uploaderReady: state =>
                state.uploader.UploadServer.loadingStatus == "done",
            uploaderResult: state => state.uploader.newMaterialStatus
        }),
        uploadImageLimit() {
            return this.$store.getters['uploader/imageMaxSize'](this.$store.state.config.uploadImageLimit);
        },
    },
    watch: {
        "watermarkSettings.fontFamily": "setAndLoadFont",
        "watermarkSettings.watermarkType": "setAndLoadFont",
        fontFamilyList: "setAndLoadFont",
        opacityPercent(v) {
            this.watermarkSettings.opacity = v / 100;
        },
        uploaderResult(val) {
            let item = val[val.length - 1];
            if (!item.status) {
                this.pagination.page == 1 && this.refresh();
            } else {
            }
        },
        zoomPercent(v) {
            this.watermarkSettings.zoomPercent = v;
        },
        "watermarkSettings.zoomPercent"(v) {
            this.zoomPercent = v;
        },
    },
    methods: {
        delaySetZoomPercent() {
            if(this.watermarkSettings.zoomPercent < 100) {
                this.watermarkSettings.zoomPercent = this.watermarkSettings.zoomPercent+0.01;
                setTimeout(() => {
                    this.watermarkSettings.zoomPercent = this.watermarkSettings.zoomPercent-0.01;
                }, 5);
            }
        },
        onUploadSelect(file, url) {
            this.watermarkSettings.imagePath = url;
            delete this.watermarkSettings.watermarkKey;
        },
        onUploadSuccess(file) {
            this.watermarkSettings.watermarkKey = file.msg.name;
        },
        async onSaveClick() {
            if(!this.hasPermission('saveWatermark')){
                this.$Notice.error({ title: this.$t('Message.permission.error') });
                return;
            }
            let saveFlag = await this.$refs.watermarkSettings.validate();
            if(!saveFlag) {
                this.$Notice.error({ title: this.$t('Message.save.error'), desc: this.$t('Message.save.hasInfoEmpty') });
                return;
            }
            try {
                if (
                    this.watermarkSettings.watermarkType ===
                    Const.Watermark.Type.Image &&
                    this.watermarkSettings.watermarkId === 0 &&
                    this.$refs.uploader.file.id &&
                    !this.watermarkSettings.watermarkKey
                ) {
                    this.save_loading = true;
                    this.$refs.uploader.upload(this.watermarkSettings.zoomPercent/50);
                    return;
                }
                
                await this.save();
            } catch (e) {
                this.$Notice.error({ title: this.$t('Message.save.error'), desc: e.resultMsg });
            }
        },
        onUploadDone() {
            this.save_loading = false;
        },
        async save() {
            if(!this.hasPermission('saveWatermark')){
                this.$Notice.error({ title: this.$t('Message.permission.error') });
                return;
            }
            if(this.id == 0 && !this.hasPermission('addWatermark')) {
                this.$Notice.error({ title: this.$t('Message.permission.error') });
                return;
            }
            if(this.id && this.id > 0 && !this.hasPermission('editWatermark')) {
                this.$Notice.error({ title: this.$t('Message.permission.error') });
                return;
            }
            this.loading = true;
            this.save_loading = true;
            try {
                let param = this.watermarkSettings;
                this.watermarkSettings.type = this.watermarkSettings.watermarkType;
                if (this.watermarkSettings.type == Const.Watermark.Type.Image) {
                    delete this.watermarkSettings.fontFamily;
                    delete this.watermarkSettings.fontSize;
                    delete this.watermarkSettings.fontColor;

                    if (this.uploadPath) {
                        param = extend(true, {}, this.watermarkSettings, {
                            content: this.uploadResult.scaleFile,
                            watermarkKey: this.uploadResult.name
                        }, {
                            softwareId: this.uploadServer.softwareId,
                            uploadServerUrl: this.uploadServer.uploadServerUrl,
                            uploadUrl: this.uploadServer.uploadUrl
                        }, {
                            uploadPath: this.uploadPath
                        });
                    }
                } else {
                    delete this.watermarkSettings.content;
                }

                await api.call(
                    "watermark/save",
                    param
                );

                this.$Notice.success({ title: this.$t('Message.save.success') });
                this.$router.back();
                this.$store.commit('uploader/setUploadPath', "");
            } catch (e) {
                let msg = e.resultMsg;
                if(msg && msg.indexOf('非法字符') > -1) {
                    msg = '包含特殊字符';
                }
                this.$Notice.error({ title: this.$t('Message.save.error'), desc: msg });
            }
            this.loading = false;
            this.save_loading = false;
        },
        async refresh() {
            this.loading = true;

            try {
                let ret = await api.call("watermark/info", {
                    watermarkId: this.id
                });
                if (ret.data) {
                    this.watermarkSettings = ret.data;
                    this.opacityPercent = this.watermarkSettings.opacity * 100;
                    // decode name
                    this.watermarkSettings.watermarkName = HtmlDecode.d(this.watermarkSettings.watermarkName);
                }
                this.uploadServer = ret.uploadJson;
            } catch (e) {}

            this.loading = false;
        },
        async refreshSysDictoryList() {
            try {
                let ret = await api.call("watermark/sysDictoryList", {});

                this.fontFamilyList = ret.data;
            } catch (e) {}
        },
        setAndLoadFont() {
            if (
                this.watermarkSettings.watermarkType ===
                Const.Watermark.Type.Text
            ) {
                let val = this.watermarkSettings.fontFamily;
                // 设置默认字体
                if (!val) {
                    this.watermarkSettings.fontFamily = this.fontFamilyList[0].fontFamily;
                }

                // 加载字体
                if (val && this.fontFamilyList.length) {
                    const font = this.fontFamilyList.find(
                        v => v.fontFamily == val
                    );
                    helper.loadFont(font.name, font.url);
                }
            }
        }
    },
    mounted() {
        this.refresh();
        this.refreshSysDictoryList();
    },
    created() {},
    beforeDestroy() {}
};
</script>
<style lang="less" scoped>
@import url("../../../assets/main-variable.less");

.modify-dialog {
    padding: -5px;
    text-align: justify;
    &:after {
        content: " ";
        display: inline-block;
        width: 100%;
    }
    & > div {
        display: inline-table;
        padding: 5px 0px;
    }
    & > p {
        width: 100%;
        display: inline-table;
        margin-top: 10px;
    }
    .color-picker {
        /deep/ .ivu-input-small {
            padding: 1px 2px;
        }
    }
    .thumb-item {
        display: block;
    }
}

.title {
    font-size: 16px;
    display: inline-block;
    height: 40px;
    line-height: 40px;
    width: 100%;
    box-sizing: content-box;
    & > * {
        vertical-align: middle;
    }
}
.subtitle {
    margin: 5px;
    height: 30px;
    line-height: 30px;
    & > * {
        vertical-align: middle;
    }
}
.thumb-item.can-active {
    border: 1px solid transparent;
}
.thumb-item.can-active:hover {
    background: #e3e3e3;
    cursor: pointer;
}
.thumb-item.can-active.active {
    background: #ffffe3;
    border: 1px solid #e3e3e3;
}
.thumb-item {
    margin: 5px;
    background: #f2f2f2;
    border: 0px solid #e3e3e3;
    border-radius: 5px;
    padding: 5px;
    box-sizing: content-box;
    height: 50px;
    line-height: 25px;
    // white-space: nowrap;
    overflow: hidden;
    color: gray;
    position: relative;
    & > * {
        vertical-align: middle;
    }
    .subtitle-thumb {
        width: 50px;
        height: 50px;
        float: left;
        object-fit: cover;
        border-radius: 3px;
        margin: 0 5px;
    }
    .up {
        position: absolute;
        right: 0;
        top: 0;
        font-size: 20px;
        color: rgba(0, 0, 0, 0.3);
    }
    .up:hover {
        background: @primary-color;
        color: white;
    }
    .down {
        position: absolute;
        right: 0;
        bottom: 0;
        font-size: 20px;
        color: rgba(0, 0, 0, 0.3);
    }
    .down:hover {
        background: @primary-color;
        color: white;
    }
    .clear-material {
        position: absolute;
        right: 18px;
        top: 12px;
    }
    .material-name {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        display: inline-block;
        max-width: 245px;
    }
    .material-viewer {
        margin: -20px 0 0 4px;
    }
}

.detail-box {
    position: relative;
    border-radius: 5px;
    background: white;
    padding-left: 400px;
    height: 100%;
    box-sizing: content-box;

    .left-box {
        width: 400px;
        position: absolute;
        height: 100%;
        padding: 20px;
        left: 0;
        top: 0;
        background: white;
        overflow: auto;

        .title {
            font-size: 16px;
            display: inline-block;
            height: 40px;
            line-height: 40px;
            width: 100%;
            box-sizing: content-box;
            & > * {
                vertical-align: middle;
            }
            .title-input {
                display: inline-block;
                width: 200px;
                input {
                    font-size: 16px;
                }
            }
        }
        & > button {
            margin: 10px 10px 10px 0;
            display: inline-block;
            width: 80px;
        }

        .subtitle {
            margin: 5px;
            height: 30px;
            line-height: 30px;
            & > * {
                vertical-align: middle;
            }
        }
    }
    .right-box {
        width: 100%;
        height: 100%;
        background: #e3e3e3;
        padding: 10px;
        text-align: left;
        .editor {
            text-align: left;
            .layout-container {
                display: inline-block;
                background-size: 100% 100%;
            }
        }
    }
}
/deep/ .input-textarea .ivu-input{
    font-size: 12px;
}
</style>
